import { companyService as ogpCompanyService } from 'ogp/services';
import { companyService as hqCompanyService } from 'hq/services';
import { useQuery } from 'react-query';
import { CompanyBasicInfo } from '@types';
import { QUERY_KEYS } from 'api/query-keys';
import { invariant } from '../../../../../../utils/utils';
import { SiteDetectionResult, useSiteDetection } from '../../../../../../hooks';

export const useGetCompanyBasicInfo = (workId?: string) => {
  const siteDetectionResult = useSiteDetection();
  const queryFn = getQueryFunction(siteDetectionResult, workId);

  return useQuery<CompanyBasicInfo>(QUERY_KEYS.companyBasicInfo(workId), queryFn);
};

function getQueryFunction(siteDetectionResult: SiteDetectionResult, workId: string | undefined) {
  if (siteDetectionResult.isHQ) {
    invariant(workId, 'useGetCompany: workId is required');
    return async () => await hqCompanyService.getCompanyBasicInfoByWorkId(workId);
  }

  if (siteDetectionResult.isOGP) {
    return async () => await ogpCompanyService.getCompanyBasicInfo();
  }

  throw new Error(`useGetCompany: site "${siteDetectionResult}" is neither HQ nor OGP.`);
}
